import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingAiProfilePictureMakerConfig } from '@/data/landingConfig/landingAiProfilePictureMakerConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_AiProfilePictureMaker } from './schemaObject';

interface Props {}
const AiProfilePictureMaker: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_AiProfilePictureMaker} />
			<LandingTemplate
				data={landingAiProfilePictureMakerConfig}
				funnelLinkService={GenerateLandingLinkService.funnelHeadshotGenerator()}
			/>
		</>
	);
};

export default AiProfilePictureMaker;
